import styled from "styled-components";

export const Image = styled.img`
  width: 170px;
  box-shadow: -10px 10px 0px 0px var(--color-secondary);

  @media (min-width: 1000px) {
    width: 260px;
  }
`;

export const Container = styled.div`
  width: 270px;
  width: 10vw;
`;

